type IconsType = { [key: string]: string };

export const ICONS: IconsType = {
    grid: "bx bxs-grid",
    shop: "bx bx-store",
};
